import InputWrapperRefacture from "../../UI/Inputs/InputWrapperRefacture";
import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import ErrorBoxCS from '../../UI/ErrorBox/ErrorBox';
import { APIPost, getEnvironment } from "../../API/APIRequest";
import SuccessBox from "../../UI/SuccessBox/SuccessBox";




export default function PromoCode(props) {


    const { fid, basket, purchasingFor, deliveryCountryCode, adToken, setActionName, updateAndRefreshBasket, promoCode, setPromoCode } = props;
    const [errorStates, setErrorStates] = useState({ "invalid": false, "blank": false, "notEligible": false })
    const [successStates, setSuccessStates] = useState({ "applied": false, "removed": false })
    const { t, i18n } = useTranslation();
   
    const [tagValue, setTagValue] = useState("");
    const [variants, setVariants] = useState("");
    const [quantities, setQuantities] = useState("");
    const [tagCounts, setTagCounts] = useState("");

    const discountCode = sessionStorage.getItem("discountApplied");
    const prevBasketFid = sessionStorage.getItem("prevFid");
    const params = new URLSearchParams(window.location.search);
    const discountRemoved= params.get("discountRemoved"); //queryParam
    const queryParamsString = sessionStorage.getItem("queryParamsString");

    
    const getPromoCodePayloadValues = () => {

        let tagCounts = {};
        let variants = [];
        let quantities = [];
        let tagValue = [];

        basket.lines.forEach(variant => {

            variants.push(variant?.productvariantid);  // for variants
            quantities.push(variant?.quantity);  // for quantity

            if (variant.tags && Array.isArray(variant.tags)) {
                variant.tags.forEach(tagObj => {
                    tagValue.push(tagObj.tag);    // for tag value
                    const tag = tagObj.tag;
                    if (tagCounts[tag]) {
                        tagCounts[tag] += variant.quantity;    //for tag counts
                    } else {
                        tagCounts[tag] = variant.quantity;
                    }
                });
            }
        });

        setTagCounts(tagCounts);
        setTagValue(tagValue.join(','));
        setQuantities(quantities.join(','));
        setVariants(variants.join(','));
    }
    
    function removeQueryParam(param) {
       
        const url = new URL(window.location.href);
        
        if (url.searchParams.has(param)) {
            url.searchParams.delete(param);
            
            window.history.replaceState({}, '', url); //need to replace the url without refresh
        }
    }
    
    useEffect(() => {

        getPromoCodePayloadValues();

        // ---- OLD redirect/sessionStorage-based detection (kept for reference) ----
        // if (discountCode) {
        //     setPromoCode(discountCode)     // on application of discount code
        //     setSuccessStates({ applied: true, removed: false })
        //     if (adToken) {
        //         setActionName("Order Discount Code")   //discount code web activity.
        //     }
        // }
        // else {
        //     if (discountRemoved) {             // on removal of discount code
        //         setSuccessStates({ applied: false, removed: true })
        //         removeQueryParam("discountRemoved");  //only should show up for the first time
        //     }
        //     else {
        //         // Pre-fill promo code from basket if a promo code was applied (e.g. default promo code)
        //         const firstLineWithPromo = basket?.lines?.find(l => l.promocodeid > 0 && l.groupdiscountcode);
        //         if (firstLineWithPromo) {
        //             setPromoCode(firstLineWithPromo.groupdiscountcode);
        //             setSuccessStates({ applied: true, removed: false });
        //         }
        //     }
        // }

        // ---- NEW: derive applied state directly from the basket. groupdiscountcode carries
        //      both promo codes and txactivity/effort discounts, so detect on it being present
        //      (promocodeid may be 0 for txactivity discounts). ----
        const lineWithDiscount = basket?.lines?.find(l => l.groupdiscountcode);
        if (lineWithDiscount) {
            setPromoCode(lineWithDiscount.groupdiscountcode);
            setSuccessStates({ applied: true, removed: false });
            if (adToken) {
                setActionName("Order Discount Code");   //discount code web activity.
            }
        }
        else if (successStates.applied) {
            // A previously applied discount is no longer on the basket - e.g. an ineligible
            // BI-filter promo removed via the "Continue" button in Payment.js. Re-sync the
            // field so it doesn't keep showing the removed code.
            setPromoCode("");
            setSuccessStates({ applied: false, removed: false });
            setErrorStates({ invalid: false, blank: false, notEligible: false });
        }

    }, [basket])


    const removePromoCode = () => {

        // ---- OLD redirect-based remove (kept for reference) ----
        // let baseUrl = "";
        // if(adToken?.isGuest){
        //    baseUrl = '/guest/' + prevBasketFid;
        // }else{
        //    baseUrl = '/payment/' + prevBasketFid;
        // }
        //
        // const existingParams = window.location.search;
        // const newParam = "discountRemoved=true";
        //
        // let prevBasketUrl = baseUrl;
        //
        // // To check for existing query parameters
        // if (existingParams) {
        //     prevBasketUrl += existingParams + "&" + newParam;
        // } else {
        //     prevBasketUrl += '?' + newParam;
        // }
        //
        // sessionStorage.removeItem("discountApplied");   // removing discount code
        // sessionStorage.removeItem("purchasingFor");    // removing session variables which were to be used for bypassing landingPage on discount code application
        // sessionStorage.removeItem("prevBasketDataForDiscountFlow");
        // sessionStorage.removeItem("prevFid");
        //
        // window.location.href = prevBasketUrl   // redirection to prev basket

        // ---- NEW: remove the discount on the same basket and refresh in place ----
        APIPost({
            "controller": "basket",
            "action": "removepromocode",
            "environment": null,
            "identifier": fid
        }).then((response) => {
            if (response.status === 200 && response?.data?.success) {
                setPromoCode("");
                setSuccessStates({ applied: false, removed: true });
                setErrorStates({ invalid: false, blank: false, notEligible: false });
                // refresh the basket in place with the returned (full price) basket
                if (updateAndRefreshBasket) {
                    updateAndRefreshBasket(deliveryCountryCode, "resetting", response.data.basket, basket?.destinationcountycode);
                }
            }
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    const applyPromoCode = (e) => {
       
        let validated = validationOnApply();

        if (validated) {

            // ---- OLD variantmappings + redirect flow (kept for reference) ----
            // const data = new FormData();
            // data.append("discountCode", promoCode);
            // data.append("tagValues", tagValue);
            // data.append("quantity", quantities);
            // data.append("variantIDs", variants);
            // data.append("tagQuantity", JSON.stringify(tagCounts));
            // data.append("origin", window.location.hostname);
            //
            // APIPost({
            //     "controller": "basket",
            //     "action": "variantmappings",
            //     "environment": null,
            //     "identifier": fid,
            //     data: data
            // }).then((response) => {
            //     if (response.status === 200) {
            //         if (response?.data) {
            //             if (response?.data?.newUrl) {
            //
            //                 let discountCode = response?.data?.discountCode;
            //                 let discountParam= `discountApplied=${discountCode}`
            //                 let newUrlWithDiscount = response?.data?.newUrl;
            //
            //                 let existingParams = queryParamsString || ""  //initial query params being retained from the session
            //
            //                // To check for existing query parameters
            //                 if (existingParams) {
            //                     newUrlWithDiscount +=  "&" + existingParams + "&" + discountParam;
            //                 } else {
            //                     newUrlWithDiscount += "&" + discountParam;
            //                 }
            //
            //                 newUrlWithDiscount = new URL(newUrlWithDiscount).toString();
            //
            //                 sessionStorage.setItem("purchasingFor", purchasingFor);    //creating session variables with data of existing basket for bypassing landingPage
            //                 sessionStorage.setItem("prevBasketDataForDiscountFlow", JSON.stringify(basket));
            //                 sessionStorage.setItem("prevFid", fid);
            //                 sessionStorage.setItem("prevDeliveryCountryCode", deliveryCountryCode);
            //                 sessionStorage.setItem("prevDeliveryCountyCode", basket?.destinationcountycode);
            //
            //                 window.location.href = newUrlWithDiscount;        //redirection to new basket with discount code applied
            //             }
            //             else {
            //                 if (response?.data?.error) {
            //                     let er = response?.data?.error;    //in case of invalid discount code
            //                     if (er === "No mapped variants found - discount code probably invalid") {
            //                         setErrorStates(errorStates => ({ ...errorStates, invalid: true }))
            //                     }
            //                 }
            //             }
            //         }
            //     }
            // }).catch((error) => {
            //     console.error('Error:', error);
            // });

            // ---- NEW: apply the promo code on the same basket and refresh in place ----
            const data = new FormData();
            data.append("promoCode", promoCode);

            APIPost({
                "controller": "basket",
                "action": "applypromocode",
                "environment": null,
                "identifier": fid,
                data: data
            }).then((response) => {
                if (response.status === 200 && response?.data?.success) {
                    const refreshedBasket = response.data.basket;
                    // valid code but the party falls inside the promo code's "Stop orders for BI filter"
                    const notEligible = refreshedBasket?.infomessages?.includes("info.promocodebifilterineligible");
                    const ineligible = refreshedBasket?.infomessages?.includes("info.discountineligible");
                    const appliedLine = refreshedBasket?.lines?.find(l => l.groupdiscountcode);

                    if (notEligible) {
                        // promo code rejected because the user is in its BI filter - distinct message, order not blocked
                        setErrorStates(errorStates => ({ ...errorStates, notEligible: true, invalid: false }));
                        setSuccessStates({ applied: false, removed: false });
                        return;
                    }

                    if (ineligible || !appliedLine) {
                        // promo code not valid for any variant in the basket
                        setErrorStates(errorStates => ({ ...errorStates, invalid: true }));
                        setSuccessStates({ applied: false, removed: false });
                        return;
                    }

                    setPromoCode(appliedLine.groupdiscountcode);
                    setSuccessStates({ applied: true, removed: false });
                    setErrorStates({ invalid: false, blank: false, notEligible: false });
                    if (adToken) {
                        setActionName("Order Discount Code");
                    }
                    // refresh the basket in place with the returned (discounted) basket
                    if (updateAndRefreshBasket) {
                        updateAndRefreshBasket(deliveryCountryCode, "resetting", refreshedBasket, basket?.destinationcountycode);
                    }
                }
            }).catch((error) => {
                // a BadRequest (e.g. info.discountineligible) lands here
                const errors = error?.response?.data?.errors;
                if (errors && errors.includes("info.promocodebifilterineligible")) {
                    setErrorStates(errorStates => ({ ...errorStates, notEligible: true }));
                } else if (errors && errors.includes("info.discountineligible")) {
                    setErrorStates(errorStates => ({ ...errorStates, invalid: true }));
                } else {
                    console.error('Error:', error);
                }
            });
        }
    }

    const handleOnChange = (value) => {
        setPromoCode(value);

        // reinitialising error states on input change
        setSuccessStates({ applied: false, removed: false })
        setErrorStates({ invalid: false, blank: false, notEligible: false })
    }
    
    
    // validation on "apply" button click
    const validationOnApply = () => {
     
        let valid = true;
        // reinitialising error states on input change
        setSuccessStates(successStates=>({...successStates, removed: false }))
        setErrorStates(errorStates => ({ ...errorStates, blank: false, invalid: false, notEligible: false }))

        if (promoCode.length < 1) {
            setErrorStates(errorStates => ({ ...errorStates, blank: true }))
            valid = false;
        }

        return valid;
    }

    const promoFieldUI = () => {
        return <div className="item-wrapper">

            <InputWrapperRefacture
                label={t('payment.promocodelabel')}
                inputSize="full-width"
                inputFieldType="text"
                btnText={successStates?.applied ? "Remove" : "Apply"}
                value={promoCode}
                id="promoCode"
                name="promoCode"
                placeholder={t('payment.promocodeplaceholder')}
                onClickFunction={successStates?.applied ? () => removePromoCode() : () => applyPromoCode(promoCode)}
                aria-invalid={errorStates?.invalid || errorStates?.blank || errorStates?.notEligible}
                aria-describedby="promocode-alerts"
                invalidClass={(errorStates?.invalid || errorStates?.blank || errorStates?.notEligible) ? "Invalid-input" : ""}
                onChange={successStates?.applied ? "" : (e) => handleOnChange(e.target.value)} />

            {errorStates?.blank && <span role="alert" id="promocode-alerts"><ErrorBoxCS>{t('payment.blankpromocode')}</ErrorBoxCS></span>}
            {errorStates?.invalid && <span role="alert" id="promocode-alerts"><ErrorBoxCS>{t('payment.invalidpromocode')}</ErrorBoxCS></span>}
            {errorStates?.notEligible && <span role="alert" id="promocode-alerts"><ErrorBoxCS>{t('payment.promocodenoteligible')}</ErrorBoxCS></span>}
            {successStates?.applied && <span role="alert" id="promocode-alerts"><SuccessBox>{t('payment.promocodeadded')}</SuccessBox></span>}
            {successStates?.removed && <span role="alert" id="promocode-alerts"><SuccessBox>{t('payment.promocoderemoved')}</SuccessBox></span>}

        </div>
    }



    return (
        <div>
            {promoFieldUI()}
          
        </div>
    )
}